import React from "react";
import PropagateLoader from "react-spinners/PropagateLoader";
import { css } from "@emotion/core";

import * as PrimaryService from "../services/service";
import {
  addModalStyles,
  removeModalStyles,
} from "../operationalHelper/modalStyles";

class SignupModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userEmail: "",
      name: "",
      identifierId: "",
      verification: false,
      loaderProgress: false,
      showSuccessModal: false,
      enableIdentifierId: false,

      validationObj: {
        email: false,
        name: false,
        identifierId: false,
      },
      postApiMessage: "",
    };
    this.override = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;
  }

  componentDidMount() {
    addModalStyles(this);
  }

  componentWillUnmount() {
    removeModalStyles(this);
  }

  changeToLoginModal = () => {
    let modal = new window.bootstrap.Modal(document.getElementById("login"));
    modal.toggle(true);
  };

  closeSuccessModal = () => {
    this.setState({
      showSuccessModal: false,
    });
    // Close the signup modal as well
    let signupModal = window.bootstrap.Modal.getInstance(
      document.getElementById("signup")
    );
    if (signupModal) {
      signupModal.hide();
    }
  };

  resetModalFields = () => {
    this.setState({
      userEmail: "",
      name: "",
      identifierId: "",
      verification: false,
      loaderProgress: false,
      showSuccessModal: false,
      enableIdentifierId: false,
      validationObj: {
        email: false,
        name: false,
        identifierId: false,
      },
      postApiMessage: "",
    });
  };

  inputHandler = (e) => {
    let { validationObj } = this.state;
    if (e.target.name === "email") {
      validationObj.email = false;
      this.setState({
        userEmail: e.target.value,
        validationObj: validationObj,
        verification: false,
        postApiMessage: "",
      });
    } else if (e.target.name === "name") {
      validationObj.name = false;
      this.setState({
        name: e.target.value,
        validationObj: validationObj,
        verification: false,
        postApiMessage: "",
      });
    } else if (e.target.name === "identifierId") {
      validationObj.identifierId = false;
      this.setState({
        identifierId: e.target.value,
        validationObj: validationObj,
        verification: false,
        postApiMessage: "",
      });
    }
  };

  validateSignup = async () => {
    let { validationObj, userEmail, name, identifierId, enableIdentifierId } =
      this.state;
    let validationFail = false;
    let nameRegex = new RegExp(/^[a-zA-Z\s]*$/);
    console.log(nameRegex.test(name.trim()));

    if (userEmail.trim() === "") {
      validationFail = true;
      validationObj.email = true;
      this.setState({
        verification: true,
        postApiMessage: "Email is required.",
      });
    } else {
      // Extract domain from email
      const emailDomain = userEmail.trim().split("@")[1]?.toLowerCase();
      
      // Check for Aviatrix employee email
      if (emailDomain === "aviatrix.com") {
        validationFail = true;
        validationObj.email = true;
        this.setState({
          verification: true,
          postApiMessage: "Aviatrix Employees don't need to Signup on this portal. You can login via SSO by clicking the Login button.",
        });
        return;
      }
      
      // Check for public email domains
      const publicEmailDomains = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "mailslurp.biz"];
      if (emailDomain && publicEmailDomains.includes(emailDomain)) {
        validationFail = true;
        validationObj.email = true;
        this.setState({
          verification: true,
          postApiMessage: "Signup is not allowed with public email domains.",
        });
        return;
      }
    }

    if (name.trim() === "") {
      validationFail = true;
      validationObj.name = true;
      this.setState({
        verification: true,
        postApiMessage: "Name is required.",
      });
    }

    // Only validate Controller ID or Customer ID if it's enabled
    if (enableIdentifierId && identifierId.trim() === "") {
      validationFail = true;
      validationObj.identifierId = true;
      this.setState({
        verification: true,
        postApiMessage: "Controller ID or Customer ID is required.",
      });
    }

    this.setState(
      {
        validationObj: validationObj,
      },
      async () => {
        if (validationFail) {
          return;
        }
        this.setState({
          loaderProgress: true,
        });
        await this.initSignUp();
      }
    );
  };

  initSignUp = async () => {
    let signUpBody = {
      user: {
        email: this.state.userEmail,
        name: this.state.name,
        providedId: this.state.identifierId,
        verified: true,
      },
    };

    try {
      // First API call - Save to database
      const dbResult = await PrimaryService.signUpUserInDB(signUpBody.user);
      if (
        dbResult.status === 400 &&
        dbResult.data.message === "CONTROLLER_ID_REQUIRED"
      ) {
        this.setState({
          enableIdentifierId: true,
          loaderProgress: false,
          postApiMessage: "Controller ID or Customer ID is required.",
        });
        return;
      } else if (dbResult.data.message === "INVALID_EMAIL_ID") {
        this.setState({
          loaderProgress: false,
          verification: true,
          postApiMessage:
            "Email does not match exists with this Controller ID or Customer ID.",
        });
        return;
      } else if (dbResult.status === 409) {
        this.setState({
          loaderProgress: false,
          verification: true,
          postApiMessage: "Email address already exists. Click on Login",
        });
        return;
        // throw new Error('Failed to save user data to database');
      } else if (dbResult.status === 500) {
        this.setState({
          loaderProgress: false,
          verification: true,
          postApiMessage: "Error in creating the user. Please try again later.",
        });
        return;
      } else if (dbResult.status !== 200) {
        this.setState({
          loaderProgress: false,
          verification: true,
          postApiMessage:
            "Controller ID or Customer ID not valid. Please Sign Up with a valid Controller ID or Customer ID.",
        });
        return;
      }
      this.setState({
        userEmail: "",
        identifierId: "",
        name: "",
        enableIdentifierId: false,
        verification: false,
        loaderProgress: false,
        showSuccessModal: true,
        postApiMessage: "",
      });
      console.log("Database save successful:", dbResult);

    } catch (error) {
      console.log("Printing failure");
      this.setState({
        loaderProgress: false,
        postApiMessage: "Credentials are invalid.",
      });
      console.log(error);
    }
  };

  render() {
    let {
      validationObj,
      verification,
      identifierId,
      userEmail,
      name,
      loaderProgress,
      postApiMessage,
      showSuccessModal,
      enableIdentifierId,
    } = this.state;

    return (
      <React.Fragment>
        <div
          className="modal fade"
          id="signup"
          tabIndex={-1}
          aria-labelledby="loginLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-xl"
            style={{
              height: "92vh",
              maxHeight: "100vh",
            }}
          >
            <div
              className="modal-content coachmark-wrapper"
              style={{
                height: "92vh",
                maxHeight: "100vh",
                borderRadius: "10px",
                border: "none",
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
              }}
            >
              <div className="half-col-1 half-col-1-signup single-on-mobile">
                <div
                  className="modal-body px-4"
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >
                  <div className="d-flex justify-content-between pb-4 mt-3">
                    <h1 className="fs-3 ">
                      <strong>Sign up</strong>
                    </h1>
                    <div>
                      Have an account?{" "}
                      <span
                        className="color-n cursor-p"
                        data-bs-dismiss="modal"
                        onClick={this.changeToLoginModal}
                      >
                        Login
                      </span>
                    </div>
                  </div>
                  {/* <form> */}
                  <div className="mb-4">
                    <input
                      className={
                        validationObj.name
                          ? "form-control border-red"
                          : "form-control"
                      }
                      placeholder="Name"
                      type="email"
                      id="name"
                      value={name}
                      aria-describedby="nameHelp"
                      name="name"
                      onChange={this.inputHandler}
                    />
                  </div>
                  <div className="mb-4">
                    <input
                      className={
                        validationObj.email
                          ? "form-control border-red"
                          : "form-control"
                      }
                      placeholder="Email"
                      type="email"
                      id="email"
                      value={userEmail}
                      aria-describedby="emailHelp"
                      name="email"
                      onChange={this.inputHandler}
                    />
                  </div>

                  {enableIdentifierId && (
                    <div className="mb-4">
                      <input
                        className={
                          validationObj.identifierId
                            ? "form-control border-red"
                            : "form-control"
                        }
                        placeholder="Controller ID or Customer ID"
                        type="text"
                        id="identifierId"
                        value={identifierId}
                        name="identifierId"
                        onChange={this.inputHandler}
                      />
                    </div>
                  )}
                  {loaderProgress && (
                    <center style={{ margin: "20px 0" }}>
                      <PropagateLoader
                        css={this.override}
                        size={15}
                        color={"#e24402"}
                        loading={true}
                      />
                    </center>
                  )}
                  <center>
                    <PropagateLoader
                      css={this.override}
                      size={15}
                      color={"#e24402"}
                      loading={false}
                    />
                  </center>
                  {verification ? (
                    <p
                      className="pt-0 fs-1 alert-text"
                      style={{ marginBottom: "20px" }}
                    >
                      {postApiMessage}
                    </p>
                  ) : (
                    ""
                  )}
                  {/* <button id="login-button" className="btn btn-outline-danger px-4 fs-1" type="submit" name="button"><strong>Signup</strong></button> */}
                  <div className="row fs-2 mb-2" style={{ marginTop: "20px" }}>
                    <div className="col-md-6 text-start">
                      <button
                        id="login-button"
                        className="btn btn-outline-danger"
                        name="button"
                        onClick={this.validateSignup}
                        disabled={loaderProgress}
                        aria-busy={loaderProgress ? "true" : "false"}
                        style={{ cursor: loaderProgress ? "not-allowed" : "pointer" }}
                      >
                        {enableIdentifierId ? "Signup" : "Next"}
                      </button>
                    </div>
                    <div className="col-md-6 text-end"></div>
                  </div>

                  <hr
                    style={{ borderTop: "1px solid #e0e0e0", margin: "30px 0" }}
                  />

                  <div
                    style={{
                      fontSize: "14px",
                      color: "#666",
                      textAlign: "left",
                    }}
                  >
                    <p style={{ fontSize: "14px", textAlign: "left" }}>
                      After successful authorization you will receive an email
                      to set your password to complete the sign up process. Once
                      you Sign Up, you'll be able to:
                    </p>
                    <ul
                      style={{
                        paddingLeft: "20px",
                        marginTop: "10px",
                        textAlign: "left",
                      }}
                    >
                      <li style={{ marginBottom: "6px", textAlign: "left" }}>
                        Access our comprehensive Knowledge Base for quick
                        answers.
                      </li>
                      <li style={{ marginBottom: "6px", textAlign: "left" }}>
                        Engage with our Support Chatbot for instant assistance
                        or create a support ticket when needed.
                      </li>
                      <li style={{ marginBottom: "6px", textAlign: "left" }}>
                        View and manage your existing tickets directly on our
                        support ticket portal.
                      </li>
                    </ul>
                  </div>
                  {/* </form> */}
                </div>
              </div>
              <div
                className="half-col-2 hide-on-mobile"
                style={{
                  position: "relative",
                  minHeight: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "40px 30px",
                  backgroundColor: "#e24402",
                }}
              >
             {enableIdentifierId &&   <div
             
                >
                  <h3
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                      marginBottom: "15px",
                      color: "#fff",
                    }}
                  >
                    Need Help Finding Your ID?
                  </h3>
                  
                  <p
                    style={{
                      fontSize: "1rem",
                      lineHeight: "1.6",
                      marginBottom: "15px",
                      textAlign: "left",
                    }}
                  >
                    Click{' '}
                    <a
                      href="/locating-controllerid-customerid"
                      target="_blank"
                      rel="noopener noreferrer"
                   
                          className="link-blue"
                    >
                       here
                    </a>{" "}
                    <span style={{ color: "#fff" }}>

                    for guidance on how to locate your Controller ID or Customer ID.
                    </span>
                  </p>
                  <hr
                    style={{ borderTop: "1px solid #e0e0e0", margin: "15px 0" }}
                  />
                  <p  style={{
                          fontSize: "1rem",
                          lineHeight: "1.6",
                          marginBottom: "15px",
                          color: "#fff",
                          textAlign: "left",
                        }}>
                         <b> Enterprise Customers: </b> <br/>
                      If you are having trouble signing up or need assistance, email{' '}
                      <a href="mailto:portal-access-help@aviatrix.com" className="link-blue">
                        portal-access-help@aviatrix.com
                      </a>{' '}
                      with your Controller/Customer ID along with a snapshot of the error message.

                      </p>
                        <hr
                    style={{ borderTop: "1px solid #e0e0e0", margin: "15px 0" }}
                  />

                      <p  style={{
                          fontSize: "1rem",
                          lineHeight: "1.6",
                          marginBottom: "15px",
                          color: "#fff",
                          textAlign: "left",
                        }}>
                          <b> PaaS Customers: </b> <br/>
                      Please send email to {' '}
                      <a href="mailto:portal-access-help@aviatrix.com" className="link-blue">
                        portal-access-help@aviatrix.com
                      </a>{' '}
                      with your Fabric ID for access to Support Portal.

                      </p>
                </div>}
              </div>

              <div className="text-end modal-x-wrapper">
                <button
                  type="button"
                  className="btn btn-close px-4 modal-close-btn-signup"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={this.resetModalFields}
                >
                  {" "}
                  <img src="img/close.png" alt="Close" />{" "}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Success Modal */}
        {showSuccessModal && (
          <div
            className="modal fade show"
            id="successModal"
            tabIndex={-1}
            aria-labelledby="successModalLabel"
            aria-hidden="false"
            style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div
              className="modal-dialog modal-dialog-centered modal-xl"
              style={{
                height: "92vh",
                maxHeight: "100vh",
              }}
            >
              <div
                className="modal-content coachmark-wrapper"
                style={{
                  height: "92vh",
                  maxHeight: "100vh",
                  borderRadius: "10px",
                  border: "none",
                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
                }}
              >
                <div className="half-col-1 half-col-1-signup single-on-mobile">
                  <div
                    className="modal-body px-4"
                    style={{ paddingTop: "10px", paddingBottom: "10px" }}
                  >
                    <div className="d-flex justify-content-between pb-4 mt-3">
                      <h1 className="fs-3">
                        <strong>✓ Sign Up Successful</strong>
                      </h1>
                    </div>

                    <div style={{ textAlign: "left" }}>
                      <p
                        className="pt-1 fs-1"
                        style={{
                          color: "#198754",
                          marginBottom: "20px",
                          lineHeight: "1.6",
                        }}
                      >
                        To complete the Sign Up process, check your email for an
                        email from{" "}
                        <span className="color-n">
                          <strong>support@aviatrix.zendesk.com</strong>
                        </span>{" "}
                        and proceed to verify your identity and set your
                        password.
                      </p>
                    </div>

                    <div
                      className="row fs-2 mb-2"
                      style={{ marginTop: "40px" }}
                    >
                      <div style={{ textAlign: "left" }}>
                        <button
                          className="btn btn-outline-danger"
                          onClick={this.closeSuccessModal}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="half-col-2 hide-on-mobile"
                  style={{
                    position: "relative",
                    minHeight: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "2px",
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <div
                    className="image-section"
                    style={{
                      width: "100%",
                      maxWidth: "400px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    <h2
                      className="color-n"
                      style={{
                        fontSize: "1.8rem",
                        fontWeight: "bold",
                        marginBottom: "20px",
                      }}
                    >
                      Welcome to Aviatrix Support!
                    </h2>
                    <p
                      style={{
                        color: "#666",
                        fontSize: "1rem",
                        lineHeight: "1.6",
                        margin: "0",
                      }}
                    >
                      You now have access to our comprehensive support
                      resources, including our Knowledge Base, Support Chatbot,
                      and ticket management system.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default SignupModal;
